import {
  Stack,
  Typography,
  TextField,
  Dialog,
  DialogContent,
  DialogTitle,
  Box,
  useTheme,
  useMediaQuery
} from '@mui/material'
import React, { useState } from 'react'
import RcmDialogCloseIcon from '../../../../shared/components/rcmdialog/RcmDialogCloseIcon'
import { login } from '../../../../system/environment/Config.json'
import RcmPrimaryButton from '../../../../shared/components/buttons/RcmPrimaryButton'

type ContactUsProps = {
  open: boolean
  handleClose: () => void
}

const ContactUs: React.FC<ContactUsProps> = ({ open, handleClose }) => {
  const [count, setCount] = useState<number>(250)
  const [textValue, setTextValue] = useState<string>()
  const theme = useTheme()
  const fullScreen = useMediaQuery(theme.breakpoints.down('sm'))

  const handleTextChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
    const value = event?.target?.value || ''
    setTextValue(value)
    setCount(250 - value.length)
  }
  const handleSubmit = () => {
    const { contactEmail: email } = login
    if (textValue && textValue.length > 0 && email) {
      const subject = 'Rockefeller Digital - Login Assistance'
      const body = encodeURIComponent(textValue)
      window.open(`mailto:${email}?subject=${subject}&body=${body}`)
      handleClose()
    }
  }
  return (
    <Dialog open={open} maxWidth="md" fullScreen={fullScreen}>
      <DialogTitle>
        <RcmDialogCloseIcon onClick={handleClose} ariaLabel="close-linkext-acct-dialog" />
      </DialogTitle>
      <DialogContent>
        <Stack spacing={2}>
          <Typography variant="h1" sx={{ fontSize: theme.typography.fontSize24 }}>
            Contact us
          </Typography>
          <Stack direction="row" justifyContent="space-between" spacing={1} flexWrap="wrap" useFlexGap>
            <Typography variant="h3">Please provide a brief summary of the issue(s) you are experiencing</Typography>
            <Typography>{`${count} characters`}</Typography>
          </Stack>
          <TextField
            maxRows={5}
            minRows={5}
            value={textValue}
            inputProps={{ maxLength: 250 }}
            multiline
            onChange={handleTextChange}
            sx={{ backgroundColor: (theme) => theme.palette.colors?.popperAlternateRowColor }}
          />
        </Stack>
        <Box mt={3} display="flex" justifyContent="center">
          <RcmPrimaryButton variant="contained" onClick={handleSubmit}>
            Submit
          </RcmPrimaryButton>
        </Box>
      </DialogContent>
    </Dialog>
  )
}

export default ContactUs
